export * from "./gradientMaterial.js";
//# sourceMappingURL=index.js.map